import { useState } from 'react';
import { useGiayBaoNo } from '@/hooks/queries/useGiayBaoNo';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const useGiayBaoNoExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();
  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const { exportGiayBaoNoExcel } = await import('../utils/export-excel');
      await exportGiayBaoNoExcel();
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};
